const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export function normalizeImageFocalPoint(point) {
  if (!Number.isFinite(point?.x) || !Number.isFinite(point?.y)) return null;
  return { x: clamp(point.x, 0, 100), y: clamp(point.y, 0, 100) };
}

export function imageFocalPointPosition(point, frame, image) {
  const focal = normalizeImageFocalPoint(point);
  if (!focal || !(frame.width > 0 && frame.height > 0 && image.width > 0 && image.height > 0)) {
    return undefined;
  }
  const scale = Math.max(frame.width / image.width, frame.height / image.height);
  // object-position aligne deux pourcentages ; le point choisi doit, lui,
  // rejoindre le centre du cadre, sans jamais découvrir ses bords.
  const position = (percent, shown, size) => shown > size
    ? clamp((shown * percent / 100 - size / 2) / (shown - size) * 100, 0, 100)
    : 50;
  return `${position(focal.x, image.width * scale, frame.width)}% ${position(focal.y, image.height * scale, frame.height)}%`;
}
